import request from '@/utils/request';
import { requestEndpoint } from '@/constants/urls';

const markdown = (code) => request({
  method: 'GET',
  url: `${requestEndpoint(code)}/markdown`,
});

const RequestMarkdownService = {
  markdown,
};

export default RequestMarkdownService;
